import { render, staticRenderFns } from "./DollarQuotationForm.vue?vue&type=template&id=183f2071&scoped=true&"
import script from "./DollarQuotationForm.vue?vue&type=script&lang=js&"
export * from "./DollarQuotationForm.vue?vue&type=script&lang=js&"
import style0 from "./DollarQuotationForm.vue?vue&type=style&index=0&id=183f2071&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183f2071",
  null
  
)

export default component.exports